import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from "react-router-dom";

        ReactDOM.render(
            <BrowserRouter basename={window.__inventoryDefaults.subFolder}>
                <div>
                    <App />
                </div>
            </BrowserRouter>
            , document.getElementById('remoteInventoryRoot'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
